// extracted by mini-css-extract-plugin
module.exports = {"tags_wrapper":"TagList_tags_wrapper__1oYSo","tag":"TagList_tag__10jmV"};